import React, { createContext, useEffect, useState } from "react";
import { Form } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import { submitReport, updateReport } from "~v2/http-request/tour-operator";

import { touroperatorInitialValues as initialValues } from "./initialvalues/initialValues";
import Notification from "../../../components/shared/Notification";
import BeautifulModal from "../../components/BeautifulModal/BeautifulModal";

export const TourOperatorContext = createContext(null);

// import { GetLocationData } from "../../utils/locationDataUtil";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ children }) => {
  const [forms] = Form.useForm();

  let navigate = useNavigate();

  const [isModalVisible, setisModalVisible] = useState(false);
  const [requestResult, setrequestResult] = useState();

  const [isFailed, setisFailed] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  const location = useLocation();
  const locationData = location.state;

  const locationDataChecking = () => {
    if (!locationData?.date && !locationData?.data.date) {
      Notification(
        "Error",
        "You are in this page without selecting a date! Please try again!",
        "error"
      );
      setShouldRedirect(true);
    }
  };

  useEffect(() => {
    if (shouldRedirect) {
      navigate("/home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRedirect]);

  useEffect(() => {
    locationDataChecking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationData]);

  const store = {
    isFailed,
    setisFailed,
  };

  const cancelHandler = () => {
    setisModalVisible(false);
    navigate(-1);
  };

  const rightOnClickHandler = () => {
    navigate(-1);
  };

  const leftOnClickHandler = () => {
    navigate(`../tour-operator/view/${requestResult?.transactionId}`, {
      replace: true,
      state: { ...requestResult },
    });
  };

  return (
    <TourOperatorContext.Provider value={store}>
      <BeautifulModal
        visible={isModalVisible}
        cancelHandler={cancelHandler}
        state={"success"}
        rightOnClickHandler={rightOnClickHandler}
        leftOnClickHandler={leftOnClickHandler}
      />
      <Form
        form={forms}
        onFinishFailed={() => setisFailed(true)}
        onFinish={(_data) => {
          let payload = {
            date: locationData?.date || locationData.data.date,
            ...(!locationData?.data ? _data : { data: _data }),
          };
          let token = localStorage.getItem("token");
          if (!locationData.data)
            submitReport(payload, token).then((res) => {
              setisModalVisible(true);
              setrequestResult(res);
            });
          else {
            updateReport(payload, token).then((res) => {
              setisModalVisible(true);
              setrequestResult(res);
            });
          }
        }}
        initialValues={locationData?.data || initialValues}
        onReset={() => {
          forms.resetFields();
          setisFailed(false);
        }}
      >
        {children}
      </Form>
    </TourOperatorContext.Provider>
  );
};
